// ZoodLeap brand assets & palette
export const BRAND_NAME = "ZoodLeap";
export const BRAND_TAGLINE = "Leap into learning";
export const ZOOD_LOGO = "/brand/logo.png";
export const ZOOD_MASCOT = "/brand/mascot.png";

export const BRAND = {
  teal: "#17BEBB", // bright brand teal (logo)
  action: "#0D9488", // accessible teal for buttons/primary
  orange: "#FF9E1B",
  yellow: "#FFD84D",
  purple: "#7A3FF2",
  cream: "#FAF7F2",
};
